import {SLUGS} from '@px/const/slugs';
import {appendTemplates} from '@px/helper/template';

export const templates: Template[] = [
  {
    slug: SLUGS.STRATEGY_SQUARE,
    loader: () => import('px-home/src/modules/strategy/strategy-square'),
  },
  {
    slug: SLUGS.MOC_STRATEGY_SQUARE,
    loader: () => import('px-home/src/modules/strategy/strategy-square'),
  },
  {
    slug: SLUGS.STRATEGY_DETAIL,
    loader: () => import('px-home/src/modules/strategy/strategy-detail'),
  },
  {
    slug: SLUGS.MOC_STRATEGY_DETAIL,
    loader: () => import('px-home/src/modules/strategy/strategy-detail'),
  },
  {
    slug: SLUGS.FUTURE_GRIDS_TRADING_CONTEST,
    loader: () => import('px-home/src/modules/strategy/trading-contest'),
  },
];
appendTemplates(templates);
